import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaSpinner, FaTimes } from 'react-icons/fa';
import styles from './Toast.module.css';

const Toast = ({ id, type, message, onClose, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose(id);
    }, 300); // Match CSS transition duration
  };

  useEffect(() => {
    // Trigger entrance animation
    setTimeout(() => setIsVisible(true), 10);

    // Auto close after duration
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className={styles.icon} />;
      case 'error':
        return <FaExclamationCircle className={styles.icon} />;
      case 'info':
        return <FaInfoCircle className={styles.icon} />;
      case 'loading':
        return <FaSpinner className={`${styles.icon} ${styles.iconSpinning}`} />;
      default:
        return <FaInfoCircle className={styles.icon} />;
    }
  };

  const toastClasses = [
    styles.toast,
    styles[type],
    isVisible && !isExiting && styles.visible,
    isExiting && styles.exiting
  ].filter(Boolean).join(' ');

  return (
    <div className={toastClasses} role="alert">
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          {getIcon()}
        </div>
        <div className={styles.message}>{message}</div>
        {type !== 'loading' && (
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Cerrar notificación"
          >
            <FaTimes size={14} />
          </button>
        )}
      </div>
      {duration > 0 && type !== 'loading' && (
        <div className={styles.progressBar}>
          <div 
            className={styles.progressBarFill}
            style={{ 
              animationDuration: `${duration}ms`,
              background: type === 'success' ? 'var(--color-success)' : 
                          type === 'error' ? 'var(--color-error)' : 
                          'var(--color-info)'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Toast;

